import React, { useRef } from "react";

const FreeUser = props => {
  const {
    analyRadius,
    analyBHHeight,
    analyPump,
    analyWL,
    meshRadius,
    meshZSplit,
    meshSplit,
    meshBias,
    modelKind,
    analyType,
    wldAmount,
    pompAmount,
    wsAr,
    mapMeshLay,
    screenZSplit,
    waterShedSelectable,
    regionModelWindowVisible,
    lakeTrData,
    initTemp,
    considerMat,
    equPermCheck,
    probThreshold,
    meshVertex,
    autoScrChk,
    changeIdoPram,
    checkModelKind,
    checkIdoPram,
    changeVisible,
    getTargetBor,
    checkTarget,
    deleteSelectedWaterShed,
    changeField,
    doExe,
    closeSw,
  } = props;
  const tbRef = useRef(null);
  return (
    <div>
      {modelKind != 3 && (
        <fieldset className="Unit l-mtS">
          <legend> 1.&nbsp;原位置条件</legend>
          <div>
            <fieldset className="Unit l-mtSSS">
              <legend>
                {" "}
                <input type="checkbox" id="idoCheck" name="1" className="check" onChange={e => changeVisible(e, "idoSize")} />
                <label htmlFor="idoCheck"></label>
                &nbsp;井戸寸法
              </legend>
              <div id="idoSize" className="optCheck">
                <div>
                  <label className="wl_label">半径(m)：</label>
                  <input className="textSSR" type="text" value={analyRadius} onChange={e => changeIdoPram(e, "ar")} onBlur={e => checkIdoPram(e, "ar")} />
                  <label className="wl_label">下端深度(m)：</label>
                  <input className="textSSR" type="text" value={analyBHHeight} onChange={e => changeIdoPram(e, "ah")} onBlur={e => checkIdoPram(e, "ah")} />
                </div>
                <div>
                  <label className="wl_label">ポンプ位置深度(m)：</label>
                  <input className="textSSR" type="text" value={analyPump} onChange={e => changeIdoPram(e, "ap")} onBlur={e => checkIdoPram(e, "ap")} />
                  <label className="wl_label">初期水位深度(m)：</label>
                  <input className="textSSR" type="text" value={analyWL} onChange={e => changeIdoPram(e, "aw")} onBlur={e => checkIdoPram(e, "aw")} />
                </div>
              </div>
            </fieldset>
          </div>
        </fieldset>
      )}
      <fieldset className="Unit l-mtSSS">
        <legend> 2.&nbsp;モデル条件</legend>
      </fieldset>

      <fieldset className="Unit l-mtSSS">
        <legend> 3.&nbsp;解析条件</legend>
        {modelKind == 1 && (
          <div className="">
            <label htmlFor="autoScrChk"></label>
            解析種別：
            <select className="selectM" value={analyType} onChange={e => changeIdoPram(e, "alt")}>
              <option value="6">井戸理論計算(Theis式)</option>
            </select>
          </div>
        )}

        {(analyType == 5 || analyType == 6) && (
          <div className="">
            <label className="kc_label">最適化計算対象ボーリング</label>
            <input className="textSSAL" id="targetKbor" type="text" disabled="disabled" value={getTargetBor} />
          </div>
        )}
      </fieldset>

      <div className="l-right l-mtS ">
        <button className="cBtn" onClick={doExe}>
          連動
        </button>
        <button className="cBtn" onClick={closeSw}>
          閉じる
        </button>
      </div>
    </div>
  );
};

export default FreeUser;
